import { useCallback, useState } from 'react';

export function useFormData<T extends Record<string, unknown>>(
  initial: T | (() => T)
) {
  const createInitial = useCallback(
    () => (typeof initial === 'function' ? (initial as () => T)() : initial),
    [initial]
  );
  const [data, setData] = useState<T>(createInitial);

  const setField = useCallback(
    <K extends keyof T>(key: K, value: T[K]) =>
      setData((prev) => ({ ...prev, [key]: value })),
    []
  );
  const reset = useCallback(() => setData(createInitial()), [createInitial]);

  return { data, setData, setField, reset };
}
